import React, { useState, useRef, useCallback } from 'react';

export default function PullToRefresh({ onRefresh, children, className, style }) {
  const [pulling, setPulling] = useState(false);
  const [pullDist, setPullDist] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(0);
  const scrollRef = useRef(null);
  const THRESHOLD = 64;

  const onTouchStart = useCallback(e => {
    if (scrollRef.current && scrollRef.current.scrollTop === 0) {
      startY.current = e.touches[0].clientY;
      setPulling(true);
    }
  }, []);

  const onTouchMove = useCallback(e => {
    if (!pulling || refreshing) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0) {
      setPullDist(Math.min(dy * 0.4, 100));
    }
  }, [pulling, refreshing]);

  const onTouchEnd = useCallback(async () => {
    if (pullDist >= THRESHOLD && !refreshing) {
      setRefreshing(true);
      setPullDist(THRESHOLD);
      await (onRefresh ? onRefresh() : new Promise(r => setTimeout(r, 800)));
      setRefreshing(false);
    }
    setPullDist(0);
    setPulling(false);
  }, [pullDist, refreshing, onRefresh]);

  const progress = Math.min(pullDist / THRESHOLD, 1);

  return (
    <div
      ref={scrollRef}
      className={className}
      style={style}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <div className="ptr-indicator" style={{
        height: pullDist > 0 || refreshing ? Math.max(pullDist, refreshing ? 48 : 0) : 0,
        opacity: progress,
      }}>
        <div className={`ptr-spinner ${refreshing ? 'ptr-spinning' : ''}`} style={{
          transform: `rotate(${progress * 360}deg)`,
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <path d="M21 12a9 9 0 11-6.22-8.56" />
          </svg>
        </div>
        {refreshing && <span className="ptr-text">Updating scores…</span>}
      </div>
      {children}
    </div>
  );
}
